import {InsuredModel} from './insured.model';
import {DriverModel} from './driver.model';
import {VehicleModel} from './vehicle.model';
import {ImpactPointModel} from './impact-point.model';
import {AdditionalCostModel} from './additional-cost.model';
import {CustomerModel} from './customer.model';
import {ContractModel, InsuranceCompanyEsb} from './contract.model';
import {FleetManagerModel} from './fleet-manager.model';
import {AntiTheftModel} from './anti-theft.model';

export class DamagedModel {
	is_cai_signed: boolean;
	insured?: InsuredModel;
	driver: DriverModel;
	vehicle: VehicleModel;
	insurance_company: InsuranceCompanyEsb;
	impact_point: ImpactPointModel;
	additional_costs: AdditionalCostModel[];
	customer?: CustomerModel;
	contract: ContractModel;
	fleet_managers: FleetManagerModel[];
	anti_theft_service: AntiTheftModel;

	constructor() {
		this.vehicle = new VehicleModel();
		this.impact_point = new ImpactPointModel();
		this.fleet_managers = [];
		this.additional_costs = [];
	}
}
